import React, {Component} from "react";
import {Form, Input, Button, DatePicker, Select} from "antd";
import moment from "moment";
const dateFormat = 'YYYY/MM/DD';
const FormItem = Form.Item;
const Option = Select.Option;
const {RangePicker} = DatePicker;


class DynamicFilter extends Component{

    constructor(props) {
        super(props);
        this.state = {

        }
        this.handleSubmit = this.handleSubmit.bind(this);

    }



    componentDidMount() {
        let _self = this;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let {onCommit} = _self.props;
                let {userId,dynamicContent,circleName,DynamicStatus,dateRange} = values;

                console.log(values)

                onCommit && onCommit(userId,dynamicContent,circleName,DynamicStatus,dateRange);
            }
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        let _self = this;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let {onCommit} = _self.props;
                let {userId,dynamicContent,circleName,DynamicStatus,dateRange} = values;

                console.log(values)

                onCommit && onCommit(userId,dynamicContent,circleName,DynamicStatus,dateRange);
            }
        });
    }
    render() {
        const {getFieldDecorator} = this.props.form;
        const {dataSource} = this.props;
        const {userId,dynamicContent} = dataSource;
        return (
            <Form onSubmit={this.handleSubmit} layout="inline">

                <FormItem label="用户展示id">
                    {getFieldDecorator('userId', {
                        initialValue: userId

                        }
                    )(
                        <Input style={{width: '150px'}} allowClear  />
                    )}
                </FormItem>

                <FormItem label="动态内容">
                    {getFieldDecorator('dynamicContent', {
                        initialValue: dynamicContent
                        }
                    )(
                        <Input style={{width: '150px'}} allowClear />
                    )}
                </FormItem>
                <FormItem label="圈子名">
                    {getFieldDecorator('circleName', {
                        initialValue: ""
                        }
                    )(
                        <Select style={{width: 120}}>
                            <Option value="">全部</Option>
                            <Option value="王者荣耀">王者荣耀</Option>
                            <Option value="和平精英">和平精英</Option>
                            <Option value="英雄联盟">英雄联盟</Option>
                        </Select>
                    )}
                </FormItem>
                <FormItem label="状态">
                    {getFieldDecorator('DynamicStatus', {
                        initialValue: ""
                        }
                    )(
                        <Select style={{width: 120}}>
                            <Option value="">全部</Option>
                            <Option value="0">正常</Option>
                            <Option value="1">已屏蔽</Option>
                        </Select>
                    )}
                </FormItem>
                <FormItem label="发布时间区间：">
                    {getFieldDecorator('dateRange', {
                        initialValue: [moment().subtract('7','day'), moment().subtract('0','day')]
                    })(<RangePicker
                        allowClear
                        format={dateFormat}
                        placeholder={['开始时间', '结束时间']}
                    />)}
                </FormItem>

                <FormItem>
                    <Button type="primary" htmlType="submit" style={{width: '100%'}}>
                        查询
                    </Button>
                </FormItem>

            </Form>
        );
    }
}



export default Form.create()(DynamicFilter);